import React from 'react';

export default function LocationDetails({
  preferredLocationLocalStorage,
  localizedData,
  showLocationDetailsModal,
  setShowLocationDetailsModal,
  setShowChangeLocationModal,
  handleSetShowChangeLocationModal,
  handleSetShowLocationDetailsModal,
}) {
  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return null;
  };

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[\s_-]+/g, '-');

  const date = new Date();
  const today = date.getDay();

  return (
    <>
      {preferredLocationLocalStorage && (
        <div className={`${showLocationDetailsModal ? '' : 'hidden'} location-details-wrapper fixed w-full h-full inset-0 overflow-x-hidden overflow-y-scroll z-50`}>
          <div className="flex justify-center px-4 py-12 md:py-24">
            <div onClick={() => setShowLocationDetailsModal(false)} className="location-details-overlay fixed inset-0 h-full w-full cursor-pointer bg-black opacity-75"></div>
            <div className="relative w-full max-w-6xl rounded-t-lg bg-white px-4 shadow">
              <div className="from-nav-light to-nav-dark -mx-4 flex items-center justify-between rounded-t-lg bg-gradient-to-r p-4">
                <h2 className="font-secondary text-lg font-bold text-white">{localizedData.optionsFields.header_labels.my_location_modal_header}</h2>
                <div>
                  <img
                    onClick={() => setShowLocationDetailsModal(false)}
                    onKeyPress={() => handleSetShowLocationDetailsModal(event, false)}
                    tabIndex={0}
                    className="location-details-close h-4 w-4 cursor-pointer"
                    src={`${localizedData.themeUri}/dist/images/close.svg`}
                    alt={localizedData.optionsFields.header_labels.my_location_close_alt_text}
                  />
                </div>
              </div>
              <div className="-mx-4 flex flex-wrap items-center py-8 px-4 md:px-16">
                <div className="w-full px-4 md:w-1/2">
                  {localizedData.optionsFields.header_labels.my_location_details && (
                    <h3 className="font-primary text-xl font-bold md:text-2xl">{localizedData.optionsFields.header_labels.my_location_details}</h3>
                  )}
                  <address className="mb-4 not-italic">
                    <div>{preferredLocationLocalStorage.address_line_1}</div>
                    <div>
                      {preferredLocationLocalStorage.address_city}, {preferredLocationLocalStorage.address_region} {preferredLocationLocalStorage.address_postal_code}
                    </div>
                  </address>
                  {preferredLocationLocalStorage.latitude && preferredLocationLocalStorage.longitude && (
                    <div className="mb-4 text-sm italic">
                      {preferredLocationLocalStorage.latitude}, {preferredLocationLocalStorage.longitude}
                    </div>
                  )}
                  <div className="mb-4">
                    <a
                      className="hover:underline"
                      target="_blank"
                      href={`https://www.google.com/maps/place/${preferredLocationLocalStorage.address_line_1},+${preferredLocationLocalStorage.address_city},+${preferredLocationLocalStorage.address_region}+${preferredLocationLocalStorage.address_postal_code}/`}
                    >
                      {localizedData.optionsFields.header_labels.my_location_get_directions}
                    </a>
                  </div>
                  <div className="mb-4">
                    {preferredLocationLocalStorage.main_phone && (
                      <div>
                        <a href={`tel:${formatPhoneNumber(preferredLocationLocalStorage.main_phone)}`}>{formatPhoneNumber(preferredLocationLocalStorage.main_phone)}</a>
                      </div>
                    )}
                    {preferredLocationLocalStorage.emails && (
                      <a className="hover:underline" href={`mailto:${preferredLocationLocalStorage.emails}`}>
                        {preferredLocationLocalStorage.emails}
                      </a>
                    )}
                  </div>
                  <a
                    href="#"
                    onClick={() => {
                      setShowLocationDetailsModal(false);
                      setShowChangeLocationModal(true);
                    }}
                    className="btn-stm btn-wheel from-primary-btn-light to-primary-btn-dark font-secondary mb-4 inline-block cursor-pointer rounded-r-full bg-gradient-to-r px-4 py-2 text-sm font-bold uppercase text-white hover:no-underline md:mb-0 md:text-base"
                  >
                    <div className="flex items-center">
                      <div className="mr-2">{localizedData.optionsFields.header_labels.my_location_change_location}</div>
                      <img src={`${localizedData.themeUri}/dist/images/wheel.svg`} className="h-8 w-8" alt="" />
                    </div>
                  </a>
                </div>
                <div className="w-full px-4 md:w-1/2">
                  <img className="hidden h-auto w-full md:block" src={`${localizedData.themeUri}/dist/images/find-all-southern-tire-mart-locations.jpg`} alt="" />
                </div>
              </div>
              <div className="bg-medium-gray -mx-4 flex flex-wrap py-8 px-4 md:px-16">
                <div className="w-full px-4 md:w-1/2">
                  {localizedData.optionsFields.header_labels.my_location_hours && (
                    <h3 className="font-primary text-xl font-bold md:text-2xl">{localizedData.optionsFields.header_labels.my_location_hours}</h3>
                  )}
                  <div className="mb-4 rounded bg-white p-4 shadow-lg">
                    <table className="w-full">
                      <tbody>
                        {preferredLocationLocalStorage.hours_monday && (
                          <tr className={`${today === 1 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.monday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_monday === 'string'
                                ? preferredLocationLocalStorage.hours_monday
                                : `${preferredLocationLocalStorage.hours_monday[0]} - ${preferredLocationLocalStorage.hours_monday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_tuesday && (
                          <tr className={`${today === 2 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.tuesday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_tuesday === 'string'
                                ? preferredLocationLocalStorage.hours_tuesday
                                : `${preferredLocationLocalStorage.hours_tuesday[0]} - ${preferredLocationLocalStorage.hours_tuesday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_wednesday && (
                          <tr className={`${today === 3 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.wednesday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_wednesday === 'string'
                                ? preferredLocationLocalStorage.hours_wednesday
                                : `${preferredLocationLocalStorage.hours_wednesday[0]} - ${preferredLocationLocalStorage.hours_wednesday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_thursday && (
                          <tr className={`${today === 4 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.thursday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_thursday === 'string'
                                ? preferredLocationLocalStorage.hours_thursday
                                : `${preferredLocationLocalStorage.hours_thursday[0]} - ${preferredLocationLocalStorage.hours_thursday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_friday && (
                          <tr className={`${today === 5 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.friday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_friday === 'string'
                                ? preferredLocationLocalStorage.hours_friday
                                : `${preferredLocationLocalStorage.hours_friday[0]} - ${preferredLocationLocalStorage.hours_friday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_saturday && (
                          <tr className={`${today === 6 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.saturday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_saturday === 'string'
                                ? preferredLocationLocalStorage.hours_saturday
                                : `${preferredLocationLocalStorage.hours_saturday[0]} - ${preferredLocationLocalStorage.hours_saturday[1]}`}
                            </td>
                          </tr>
                        )}
                        {preferredLocationLocalStorage.hours_sunday && (
                          <tr className={`${today === 0 && 'bg-light-gray font-bold'}`}>
                            <td className="p-2">{localizedData.optionsFields.header_labels.sunday}</td>
                            <td className="p-2">
                              {typeof preferredLocationLocalStorage.hours_sunday === 'string'
                                ? preferredLocationLocalStorage.hours_sunday
                                : `${preferredLocationLocalStorage.hours_sunday[0]} - ${preferredLocationLocalStorage.hours_sunday[1]}`}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="w-full px-4 md:w-1/2">
                  {preferredLocationLocalStorage.commercial_services && preferredLocationLocalStorage.commercial_services.length > 0 ? (
                    <>
                      <h3 className="font-primary text-xl font-bold md:text-2xl">{localizedData.optionsFields.header_labels.my_location_services}</h3>
                      <ul className="wp-block- mb-2 list-outside list-disc pl-4">
                        {Array.isArray(preferredLocationLocalStorage.commercial_services[0])
                          ? // If commercial_services[0] is an array, iterate over its elements
                            preferredLocationLocalStorage.commercial_services[0].map((service, key) => (
                              <li className="text-sm" key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))
                          : // If services[0] is not an array, split the string and iterate over its elements
                            preferredLocationLocalStorage.commercial_services.split(',').map((service, key) => (
                              <li className="w-full pr-6 text-sm " key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))}
                      </ul>
                    </>
                  ) : preferredLocationLocalStorage.retail_services && preferredLocationLocalStorage.retail_services.length > 0 ? (
                    <>
                      <h3 className="font-primary text-xl font-bold md:text-2xl">{localizedData.optionsFields.header_labels.my_location_services}</h3>
                      <ul className="wp-block- mb-2 list-outside list-disc pl-4">
                        {Array.isArray(preferredLocationLocalStorage.retail_services[0])
                          ? // If retail_services[0] is an array, iterate over its elements
                            preferredLocationLocalStorage.retail_services[0].map((service, key) => (
                              <li className="text-sm" key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))
                          : // If services[0] is not an array, split the string and iterate over its elements
                            preferredLocationLocalStorage.retail_services.split(',').map((service, key) => (
                              <li className="w-full pr-6 text-sm " key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))}
                      </ul>
                    </>
                  ) : preferredLocationLocalStorage.services && preferredLocationLocalStorage.services.length > 0 ? (
                    <>
                      <h3 className="font-primary text-xl font-bold md:text-2xl">{localizedData.optionsFields.header_labels.my_location_services}</h3>
                      <ul className="wp-block- mb-2 list-outside list-disc pl-4">
                        {Array.isArray(preferredLocationLocalStorage.services[0])
                          ? // If services[0] is an array, iterate over its elements
                            preferredLocationLocalStorage.services[0].map((service, key) => (
                              <li className="text-sm" key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))
                          : // If services[0] is not an array, split the string and iterate over its elements
                            preferredLocationLocalStorage.services.split(',').map((service, key) => (
                              <li className="w-full pr-6 text-sm " key={`service-${key}`}>
                                {service.replaceAll('"', '')}
                              </li>
                            ))}
                      </ul>
                    </>
                  ) : null}
                  <a className="hover:underline" target="_blank" href={`/locations/store-${preferredLocationLocalStorage.entity_id}`}>
                    {localizedData.optionsFields.header_labels.my_location_see_complete_details}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
